module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-check-6f5bbb6f.svg";